import generateContext, { createAction } from '@shared/context';
import { OrderStatus } from '../orders';

interface IOrderFilterState {
  activeOrderFilter: Array<OrderStatus>
}

const initialState: IOrderFilterState = {
  activeOrderFilter: []
};

enum OrderFilterActionType {
  ActiveOrderFilter = 'ACTIVE_ORDER_FILTER',
  FlushOrderFIlter = 'FLUSH_ORDER_FILTER',
}

const reducer = (
  state: IOrderFilterState ,
  action: { type: OrderFilterActionType; payload?: any }
): IOrderFilterState  => {
  switch (action.type) {
    case OrderFilterActionType.ActiveOrderFilter:
      return {
        ...state,
        activeOrderFilter: action.payload
      };
    
    case OrderFilterActionType.FlushOrderFIlter:
      return {
        ...state,
        activeOrderFilter: []
      };
    default:
      return state;
  }
};

const [OrderFilterCtxProvider, useOrderFilterState, useOrderFilterDispatch] =
  generateContext(reducer, initialState);

const useOrderFilterActions = () => {
  const dispatch = useOrderFilterDispatch();

  const setOrderFilter = (payload: OrderStatus[]) => {
    dispatch(createAction(OrderFilterActionType.ActiveOrderFilter, payload));
  };

  const flushOrderFilter = () => {
    dispatch(createAction(OrderFilterActionType.FlushOrderFIlter));
  }
 
  return {
    setOrderFilter,
    flushOrderFilter
  };
};

export { OrderFilterCtxProvider, useOrderFilterState, useOrderFilterActions, };
